import { Button, FormGroup, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import { useFormik } from 'formik'
import React, { useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import { Rating } from 'react-simple-star-rating'
import { Container, ContainerForm, Title } from '../../styles/index.sty';
import AlertSnack from '../../components/Alert/AlertSnack'
import { useAuth } from '../../context/authContext'
import { useLists } from '../../context/listContext'
import { insertReviewByProductData, updateReviewData } from '../../api/reviews.api';

const fillColorArray = [
  "#f17a45",
  "#f17a45",
  "#f19745",
  "#f19745",
  "#f1a545",
  "#f1a545",
  "#f1b345",
  "#f1b345",
  "#f1d045",
  "#f1d045"
];

export const AddReview = () => {
  const { config } = useAuth();
  const { fetchReviewsList, productsList } = useLists();
  const navigate = useNavigate();
  const location = useLocation();
  const [ product_id, setProduct_id] = useState(location?.state?.data?.product_id);
  const [ loading, setLoading ] = useState(false);
  const [open, setOpen] = useState(false);
  const [rating, setRating] = useState(location?.state?.data?.rating || 0)
  const [ response, setResponse ] = useState({});
  const formik = useFormik({
    initialValues: {
    review: location?.state?.data?.review,
    },
    onSubmit: async values => {
      setLoading(true);
      if (location?.state?.data) {
        const submit = await updateReviewData({...values, rating, review_id: location?.state?.data?.review_id, product_id }, config);
        setResponse(submit);
        setOpen(true);
        fetchReviewsList();
        if(submit.status === "success") {
          navigate("/reviews");
        }
      } else {
        const submit = await insertReviewByProductData({...values, rating, product_id}, config);
        setResponse(submit);
        fetchReviewsList();
        setOpen(true);
        if(submit.status === "success") {
          navigate("/reviews");
        }
      }
    },
  });
  
  const handleRating = (rate) => {
    setRating(rate)
  }

  return (
    <>
    <Container>
      <Title variant='h5' className='w-[100%]'>Enter Review Details.</Title>
      <ContainerForm>
      {open && <AlertSnack open={open} setOpen={setOpen} response={response} setLoading={setLoading} route="customers"/>}

      {loading ?
        <div className='items-center'>
          <BeatLoader color="#36d7b7" />
        </div>
        :
      <div style={{width : "60%", margin: "auto"}} >
        <FormGroup>
          <InputLabel id="demo-simple-select-label">Product:</InputLabel>
          <Select
            id="demo-simple-select"
            value={product_id}
            style={{ textAlign: "left"}}
            onChange={(e) => {
              setProduct_id(e.target.value);
            }}
          >
          {
            productsList.map((prod) => {
              return(
                <MenuItem value={prod.product_id}>{prod.product_name}</MenuItem>
              )
            })
          }
          </Select>
        </FormGroup><br/>
        <FormGroup>
          <InputLabel htmlFor="review">Review: </InputLabel>
          <OutlinedInput
            name="review"
            placeholder="Enter Review"
            id="review"
            type="text"
            value={formik.values.review}
            onChange={formik.handleChange}
            />
        </FormGroup><br/>
        <div className='w-100 relative flex flex-row'>
          {/* <InputLabel htmlFor="review">Rating: </InputLabel> */}
          <Rating
              onClick={handleRating}
              size={35}
              transition
              allowFraction
              showTooltip
              tooltipDefaultText={0}
              // initialValue={0}
              fillColorArray={fillColorArray}
          />
        </div>
        <div className='flex flex-row justify-between'>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={() => navigate("/reviews")}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Back
          </Button>
          <Button
            type="button"
            variant='contained'
            color='info'
            onClick={formik.handleSubmit}
            style={{
              marginTop: "1rem",
              width: "48%"
            }}
            >
            Save & Continue
          </Button>
        </div>
        {/* <Button
          fullWidth
          type="button"
          variant='contained'
          color='info'
          onClick={logList}
          style={{
            margin: "1rem auto"
          }}
          >
          Click Me TO Check
        </Button> */}
        </div>}
      </ContainerForm>
    </Container>
    </>
  )
};